export function isValidHttpUrl(string: string): boolean {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    /* istanbul ignore next */
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}
